// src/queries/voucher.query.jsx
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, postRequest, putRequest, deleteRequest } from 'utils/http'

const VOUCHER_QUERY_KEY = 'vouchers'

export const getVouchers = async (page = 1, per_page = 20, search = '', event_id = '') => {
  return getRequest('vouchers', {
    params: {
      page,
      per_page,
      search,
      event_id,
    },
  })
}

export const useGetVouchers = (page = 1, per_page = 20, search = '', event_id = '') => {
  return useQuery({
    queryKey: [VOUCHER_QUERY_KEY, page, per_page, search, event_id],
    queryFn: () => getVouchers(page, per_page, search, event_id),
  })
}

export const createVoucher = async (data) => {
  return postRequest('vouchers', data)
}

export const useCreateVoucher = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createVoucher,
    onSuccess: () => {
      queryClient.invalidateQueries([VOUCHER_QUERY_KEY])
    },
  })
}

export const updateVoucher = async ({ id, data }) => {
  return putRequest(`vouchers/${id}`, data)
}

export const useUpdateVoucher = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateVoucher,
    onSuccess: () => {
      queryClient.invalidateQueries([VOUCHER_QUERY_KEY])
    },
  })
}

export const deleteVoucher = async (id) => {
  return deleteRequest(`vouchers/${id}`)
}

export const useDeleteVoucher = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteVoucher,
    onSuccess: () => {
      queryClient.invalidateQueries([VOUCHER_QUERY_KEY])
    },
  })
}

// ── Bulk Generation ────────────────────────────────────────────────────────────
export const bulkGenerateVouchers = async (data) => {
  return postRequest('vouchers/bulk-generate', data)
}

export const useBulkGenerateVouchers = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: bulkGenerateVouchers,
    onSuccess: () => {
      queryClient.invalidateQueries([VOUCHER_QUERY_KEY])
    },
  })
}

// ── Stats ──────────────────────────────────────────────────────────────────────
export const getVoucherStats = async () => {
  return getRequest('vouchers/stats')
}

export const useGetVoucherStats = () => {
  return useQuery({
    queryKey: [VOUCHER_QUERY_KEY, 'stats'],
    queryFn: getVoucherStats,
  })
}
